<template>
    <label class="ux-field-title" v-if="showLabel">{{label}} <span class="ux-required-marker" v-if="required">*</span></label>
    <div class="ux-field-description" v-if="showDescription">{{description}}</div>
    <div v-if="multiValue">
        <flex-row class="ux-text-row" gap :key="index" v-for="(entry, index) in model">
            <flex-cell shrink>
                <input type="color" class="ux-field-focus ux-color-input ux-color-input-multiple" @focus="touch" ref="input" v-model="model[index]" />
            </flex-cell>
            <flex-cell>
                <input type="text" class="ux-field-focus ux-text-input-multiple" @focus="touch" ref="input" v-model="model[index]" />
            </flex-cell>
            <flex-cell shrink vcenter>
                <ux-button tag="a" icon v-if="canRemoveValue" @click="remove(entry)">
                    <ux-icon icon="fa-times" />
                </ux-button>
            </flex-cell>
        </flex-row>
        <ux-button v-if="canAddValue" @click="add()">{{addLabel}}</ux-button>
    </div>
    <template v-else>
        <flex-row class="ux-text-row" gap>
            <flex-cell shrink>
                <input type="color" class="ux-field-focus ux-color-input ux-color-input-single" @focus="touch" v-model="model" />
            </flex-cell>
            <flex-cell>
                <input type="text" class="ux-field-focus ux-text-input-single" @focus="touch" v-model="model" />
            </flex-cell>
        </flex-row>
    </template>
</template>
<script>
import InputMixin from './input-mixin';


//////////////////////////

export default {
    props: {
        modelValue: {
            type: String,
        },
    },
    mixins: [InputMixin],
    methods: {
        cleanInputValue(str) {
            return str;
            // const cleaned = str.split(':').join('');
            // return cleaned;
        },
        cleanOutputValue(hex) {

            if(!hex) {
                return hex;
            }

            if(String(hex)[0] === '#') {
                hex = hex.slice(1);
            }

            hex = hex || '';
            if (hex.length === 3) {
                hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
            }


            if(!hex) {
                return hex;
            }

            // `${hours}:${mins}`;
            return `#${hex}`;
        },
        getNewDefaultEntry() {
            return '';
        },
    },
}
</script>
<style lang="scss" scoped>
.ux-text-row {
    margin-bottom: 0.5em;
}

input {
    border-radius: 0.1em;
    padding: 0.5em;
    box-sizing: border-box;
    // background: rgba(#000, 0.05);
    // border: 1px solid rgba(#000, 0.1);
@extend .basic-input-style;

    
    font-size: inherit;
    // appearance: none;
    font-family: inherit;
    line-height: 1;
    height: 2.5em;

    &:focus {
        background: none;
        border: 1px solid var(--primary);
        outline: none;
    }

    &.ux-color-input {
        padding:0.1em;
    }
}

.ux-text-row .ux-btn {
    margin-left: 0.25em;
}

.ux-text-input-multiple {
    width: 100%;
}

.ux-text-input-single {
    width: 100%;
    // width: calc(100% - 0.5em);
    // margin: 0 0.5em 0 0;
}
</style>